import React, { useState, useEffect } from 'react';
import { useAuth } from './auth';
import { NotificationsSettings } from './NotificationSettings';
import { useNavigate } from 'react-router-dom';
import CardWrapper from './CardWrapper'; 

export const SubscriptionPage = () => (
  <CardWrapper>
    <h2>Subscription Settings</h2>
    <div className="current-plan-section">
      <h3>Current Plan</h3>
      <p>It is pre-launch, so all features are free for now.</p>


      <button disabled>Change Plan (disabled)</button>
    </div>
    <div className="available-plans-section">
      <h3>Available Plans</h3>
      <ul>
      <li>Beta Tester Plan - $4.99/month</li>
      <li>Standard Plan - $9.99/month</li>
      </ul>
    </div>
  </CardWrapper>
);

export const HourlyRatePage = () => (
  <CardWrapper>
    <h2>Hourly Rate Settings</h2>
    <p>
      Set your hourly rate for training sessions.

      This will be used for client billing and payment processing.

      If you are a client, this affects nothing.
    </p>
    <form>
      <label>
        Hourly Rate ($):
        <input disabled type="number" min="0" step="1" defaultValue="50" />
      </label>
    </form>
  </CardWrapper>
);

export const PrivacyPage = () => (
  <CardWrapper>
    <h2>Privacy Settings</h2>

    <p>Note: These are demo settings and do nothing yet.</p>
    <p>Manage your privacy preferences.</p>
    <div>
      <label>
        <input type="checkbox" disabled defaultChecked />
        Make my profile visible
      </label>
    </div>
    <div>
      <label>
        <input type="checkbox" disabled defaultChecked />
        Allow others to see my workout history
      </label>
    </div>
  </CardWrapper>
);

export const ManageAccountPage = () => {
  const { user, deleteAccountHandler } = useAuth();
  const  navigate  = useNavigate();

  if (!user) {
    navigate('/');
    return null;
  }

  return (
    <CardWrapper>
      <h2>Manage Account</h2>
      <p> Name: {user.name}</p>
      <p> Email: {user.email}</p>
      <p> Phone: {user.phone}</p>
      <p> Role: {user.role }</p>

      <p>
        {/* Client Registration Info: { user.client ? 
              JSON.stringify(user.client) 
              : 'No client info available' } */}
      </p>
      <p>
        {/* Trainer Registration Info: {user.trainer_info ? 
          JSON.stringify(user.trainer_info)
        : 'No trainer info available' } */}
      </p>
      
      <button
        onClick={deleteAccountHandler}
      >Delete Account</button>
    </CardWrapper>
  );
}

export const LogoutPage = () => {
  const { logout } = useAuth();
  return (
    <CardWrapper>
      <h2>Logout</h2>
      <p>Click the button below to log out.</p>
      <button onClick={logout}>Log Out</button>
    </CardWrapper>
  );
};
